import * as Yup from "yup";

const TemplateSchema = Yup.object().shape({
  name: Yup.string().required("Required"),
  subject: Yup.string().required("Required"),
  body: Yup.string().required("Required"),
});

export default TemplateSchema;
